import React, { Component } from 'react';
import { createOptionalContext } from '../../utils/create-optional-context.js';
const [TableContext, TableContextConsumer, TableContextProvider, useTable,] = createOptionalContext('TableContext');
class TableProvider extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            columnListeners: new Set(),
            columns: new Map(),
        };
        this.addColumnListener = (listener) => {
            const { columnListeners } = this.state;
            if (columnListeners.has(listener)) {
                throw Error('');
            }
            this.setState({
                columnListeners: columnListeners.add(listener),
            });
            return () => {
                this.setState((previousState) => {
                    const { columnListeners } = previousState;
                    columnListeners.delete(listener);
                    return { columnListeners };
                });
            };
        };
        this.addOrUpdateColumn = (column) => {
            this.setState((previousState) => ({
                columns: previousState.columns.set(column.id, column),
            }), () => this.notifyListeners());
            return () => {
                this.setState((previousState) => {
                    const { columns: previousColumns } = previousState;
                    previousColumns.delete(column.id);
                    return { columns: previousColumns };
                }, () => this.notifyListeners());
            };
        };
        this.getColumns = () => {
            const { columns } = this.state;
            return Array.from(columns.values());
        };
        this.notifyListeners = () => {
            const { columnListeners } = this.state;
            columnListeners.forEach((listener) => listener());
        };
    }
    render() {
        const { addColumnListener, addOrUpdateColumn, getColumns } = this;
        const { children } = this.props;
        const context = {
            addColumnListener,
            addOrUpdateColumn,
            getColumns,
        };
        return (React.createElement(TableContextProvider, { value: context }, children));
    }
}
export { TableContext, TableContextConsumer, TableProvider, useTable, };
//# sourceMappingURL=table-context.js.map